import { render, staticRenderFns } from "./ContactWithHistory.vue?vue&type=template&id=3ee9a2b0&"
import script from "./ContactWithHistory.vue?vue&type=script&lang=ts&"
export * from "./ContactWithHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports